import { i18n as I18Next } from 'i18next'
import Backend from 'i18next-locize-backend'
import { locizePlugin } from 'locize'

export const applyLocizeExtraPlugins = (i18next: I18Next) => {
	i18next.use(Backend)

	const isLocizePluginEnabled = true

	if (isLocizePluginEnabled) {
		i18next.use(locizePlugin)
	}
}
